"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const constants_1 = require("@/constants");
const styles_scss_1 = __importDefault(require("../styles.scss"));
const LinkCell = ({ cell, value }) => {
    const { row } = cell;
    const rowUser = row === null || row === void 0 ? void 0 : row.original;
    return (react_1.default.createElement(components_1.Link, { className: styles_scss_1.default.linkCell, to: `${constants_1.Routes.PatientProgress}/${rowUser === null || rowUser === void 0 ? void 0 : rowUser.id}` },
        react_1.default.createElement("div", { className: styles_scss_1.default.cell }, value)));
};
exports.default = {
    LinkCell,
};
